<!--模板-->
<template>
  <div id="head">
    <!--**导航栏区域 -->
    <div class="sec_header nobg">
      <div class="mid clear">
        <div class="lay_logo fl" @click="push('/',1)">
          <a class="logo"><img class="fixPNG" src="../../../static/images/logo.png" alt="陪伴玩 - 找陪玩,电竞,陪练,私人导游,导游,伴游预约预定技能服务平台" /></a>
        </div>
        <div class="lay_navbar fl">
          <ul>
            <li><a :class="{'on' : $route.meta.active == '/'}" @click="push('/',1)">首页</a></li>
            <li><a :class="{'on' : $route.meta.active == 'hotList'}" @click="push('/hotList',2)">陪玩</a></li>
            <li><a :class="{'on' : $route.meta.active == 'encounter'}" @click="push('/encounter',4)">偶遇</a></li>
            <!-- 待开发 -->
            <!-- <li><a :class="{'on' : $route.meta.active == 'sponsorList'}" @click="push('/sponsorList',3)">心愿众筹</a></li> -->
            <li><a :class="{'on' : $route.meta.active == 'city'}" @click="push('/city',5)">目的地</a></li>
            <li><a :class="{'on' : $route.meta.active == 'customization'}" @click="push('/customization',6)">旅行定制</a></li>
            <li><a :class="{'on' : $route.meta.active == 'team'}" @click="push('/team',7)">团队企业服务</a></li>
            <li><a :class="{'on' : $route.meta.active == 'download'}" @click="push('/download',8)">下载APP</a></li>
          </ul>
        </div>
        <!--未登录-->
        <div class="lay_lg_reg fr">
          <ul v-if="loginShow == null">
            <li><a @click="login_btn('login')">登录</a></li>
            <li><a @click="login_btn('register')">注册</a></li>
            <li class="guide"><a @click="login_btn('login')">成为陪陪</a></li>
          </ul>
        </div>
        <!--已登录-->
        <div class="lay_lg_reg fr" @mouseenter.stop="name_push(0)" @mouseleave.stop="name_push(1)">
          <ul v-if="loginShow != null" class="loginName" @click="push('/home/personal')">
            <li class="name_top">
              <img :src="nameData.headImg ? nameData.headImg : '../../../static/images/icon_big_tips.png'" height="330" width="330" />
              <!--                <span style="font-size: 20px">张三</span>-->
            </li>
            <li class="guide"><a @click="push('/home/personal')">个人中心</a></li>
          </ul>
          <div class="logpush">
            <a class="pushcol">
              <span @click="push('/home/personal')">个人中心</span>
            </a>
            <a class="pushcol" style="margin-top:10px">
              <span @click="close()">退出登录</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<!--JS-->
<script>
import $ from 'jquery'
import {
  indexUserData
} from 'api/apis'
export default {
  props: ['barShow'],
  data () {
    return {
      loginShow: localStorage.getItem("pbw_user_pc_uid"),
      barIndex: 1,
      nameData: ''
    }
  },
  watch: {
    loginShow () {
      let vm = this
      if (localStorage.getItem("pbw_user_pc_uid")) {
        // 获取个人信息
        indexUserData({
          'uid': localStorage.getItem("pbw_user_pc_uid")
        }).then((res) => {
          vm.nameData = res.data
        })
      }
    }
  },
  methods: {
    close () {
      localStorage.removeItem("pbw_user_pc_uid")
      $('.logpush').hide();
      this.$router.push('/')
    },
    name_push (index) {
      if (index == 0) {
        setTimeout(() => {
          $('.logpush').css({
            height: '0px'
          });
          $('.logpush').show();
          $('.logpush').animate({
            height: '123px'
          });
        }, 300)
      } else {
        $('.logpush').animate({
          height: '0px'
        });
        setTimeout(() => {
          $('.logpush').hide();
        }, 300)
      }
    },
    push (type, index) {
      this.barIndex = index
      this.$router.push(type)
    },
    login_btn (type) {
      // this.$message.error("暂不开放，可先关注微信公众号[陪伴玩wan]，敬请期待！~");
      // return
      if (type == 'login') {
        this.$router.push('/login')
      }
      if (type == 'register') {
        this.$router.push('/register')
      }
    }
  },
  mounted: function () {
    let vm = this
    if (localStorage.getItem("pbw_user_pc_uid")) {
      // 获取个人信息
      indexUserData({
        'uid': localStorage.getItem("pbw_user_pc_uid")
      }).then((res) => {
        vm.nameData = res.data
      })
    }
  },
  updated: function () {
    this.loginShow = localStorage.getItem("pbw_user_pc_uid")
  }
}
</script>


<!--css样式-->
<style lang="scss" scoped>
@import '../../../src/scss/commonH5.scss'; // @import '../../scss/demo.scss';
.name_top {
  display: flex !important;
  align-items: center;
  justify-items: center;
}
.name_top span {
  padding: 0 10px;
}
.loginName {
  height: 50px;
  display: flex;
  align-items: center;
}
.loginName img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
/* ==== 顶部导航栏区域.header {{{ ==== */
.sec_header {
  background: url(../../../static/images/icon-hdnav-bg.png) repeat;
  /*height: 80px;*/
  width: 100%;
  z-index: 999;
  position: relative;
  top: 0;
  box-shadow: 0 2px 6px rgba(50, 50, 50, 0.4) !important;
  transition: all 0.5s ease-in-out;
  background: #474664;
}
.sec_header.nobg {
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}
.sec_header .lay_logo {
  margin-top: 10px;
}
.sec_header .lay_logo img {
  display: block;
  width: 170px;
  height: 50px;
}
/* navbar */
.sec_header .lay_navbar {
  margin-left: 52px;
}
.lay_navbar ul li {
  display: inline;
  float: left;
  margin-right: 40px;
  cursor: pointer;
}
.lay_navbar ul li a {
  color: #ffffff;
  display: block;
  font: 18px 'sans-serif';
  height: 70px;
  line-height: 70px;
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
}
.lay_navbar ul li a:hover {
  border-bottom: 2px solid $fontColor;
  color: $fontColor;
}
.lay_navbar ul li a.on {
  border-bottom: 2px solid $fontColor;
  color: $fontColor;
}
/* lg-reg */
.sec_header .lay_lg_reg {
  height: 70px;
  display: flex;
  align-items: center;
  position: relative;
}
.lay_lg_reg ul li {
  display: inline;
  float: left;
  cursor: pointer;
  margin-right: 10px;
}
.lay_lg_reg ul li a {
  color: #ffffff;
  display: block;
  font: 16px 'sans-serif';
  height: 30px;
  line-height: 30px;
}
.lay_lg_reg ul li.guide a {
  background: $fontLinear;
  border-radius: 2px;
  text-align: center;
  margin-top: -4px;
  padding: 3px 0;
  vertical-align: top;
  width: 110px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 1);
  transition: all 0.3s;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  color: #fff;
}
.lay_lg_reg ul li.guide a:hover {
  background: $fontLinear;
}
/* }}} */
</style>

<style lang="scss">
@import '../../../src/scss/commonH5.scss';
#head .logpush {
  position: absolute;
  width: 152px;
  height: 123px;
  background: url(../../../static/images/push.png) no-repeat top;
  top: 67px;
  right: 0px;
  display: none;
}
#head .logpush a:hover {
  background: #fff;
  color: $fontColor;
}
#head .logpush .pushcol {
  cursor: pointer;
  width: 100%;
  float: left;
  text-align: center;
  font-size: 16px;
  color: #fff;
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/header/headers.vue